import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { AlternateUnitOfMeasure } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class AlternateUnitOfMeasureService extends TmsWebBaseEditCreateService<
  AlternateUnitOfMeasure,
  AlternateUnitOfMeasure
> {
  public refreshDetails = new Subject<void>();

  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('AlternateUnitOfMeasure', $localize`Alternate Unit of Measure`, httpService, notificationService);
  }

  getForUnitOfMeasure(id: string): Observable<AlternateUnitOfMeasure[]> {
    return this.httpService.get<AlternateUnitOfMeasure[]>(`${this.apiUrl}/GetForUnitOfMeasure/${id}`);
  }
}
